import { render, staticRenderFns } from "./ProductStatusComponent.vue?vue&type=template&id=fea3def4&"
import script from "./ProductStatusComponent.vue?vue&type=script&lang=js&"
export * from "./ProductStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports